import * as React from 'react'
import * as PropTypes from 'prop-types'
import styled from 'styled-components'
import TextInput from '../../../../components/ui/SimplifiedLogin/TextInput/TextInput'
import ActionButton from '../../../../components/ui/ActionButton/ActionButton'

// ST-7185 - Registration :: Referral Page : Remove Page
import {
  ReferralContainer,
  ReferralTitle,
  ReferralDescription,
} from '../MainView/MainView.style'
// import { setGAEvent } from '../../../../services/analytics/google-analytics'

const ButtonWrapper = styled.div`
  margin: 1rem 0 0;
`
const StyledButton = styled(ActionButton)`
  width: 100%;
`

function RegisterForm(props) {
  const {
    handleSubmit,
    handleChange,
    handleBlur,
    values,
    errors,
    touched,
    isSubmitting,
    disabled,
    method,
    action,
    hasThirdPartyToken,
    setFieldValue,
    // isValid,
  } = props

  const clearValues = () => {
    if (setFieldValue) {
      setFieldValue('firstName', '')
      setFieldValue('lastName', '')
      setFieldValue('email', '')
      setFieldValue('mobileNumber', '')
      setFieldValue('referralCode', '')
    }
  }
  React.useEffect(() => {
    // clear values when leaving register details form
    return () => {
      clearValues()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <form
      onSubmit={handleSubmit}
      method={method}
      action={action}
      autoComplete="off"
      data-testid="registerForm"
    >
      <fieldset disabled={isSubmitting || disabled}>
        <TextInput
          name="firstName"
          type="text"
          bold="bold"
          label="First Name"
          data-testid="registerFirstName"
          initialValue={values.firstName}
          error={errors.firstName}
          touched={touched.firstName}
          onChange={handleChange}
          onBlur={handleBlur}
          maxLength={25}
        />
        <TextInput
          name="lastName"
          type="text"
          bold="bold"
          label="Last Name"
          data-testid="registerLastName"
          initialValue={values.lastName}
          error={errors.lastName}
          touched={touched.lastName}
          onChange={handleChange}
          onBlur={handleBlur}
          maxLength={25}
        />
        <TextInput
          name="email"
          type="email"
          bold="bold"
          label="Email"
          data-testid="registerEmail"
          info="We'll verify your email address after you create an account."
          initialValue={values.email}
          error={errors.email}
          touched={touched.email || hasThirdPartyToken}
          disabled={hasThirdPartyToken}
          readOnly={hasThirdPartyToken}
          onChange={handleChange}
          onBlur={handleBlur}
        />
        <input
          name="mobileNumber"
          data-testid="registerMobileNumber"
          type="hidden"
          maxLength={11}
          onChange={handleChange}
          value={values.mobileNumber}
        />

        {/* <-- ST-7185: Registration :: Referral Page : Remove Page */}
        {/* 
        <ReferralContainer>
          <ReferralTitle>I have a promo code!</ReferralTitle>
          <ReferralDescription>
            Enter the code here for special promos or rewards.
          </ReferralDescription>
          <TextInput
            name="referralCode"
            type="text"
            bold="boldest"
            valueColor="primary"
            label="Enter Unique Referral Code (Optional)"
            data-testid="registerReferralCode"
            maxLength={15}
            initialValue={values.referralCode}
            error={errors.referralCode}
            touched={touched.referralCode}
            onChange={handleChange}
            onBlur={handleBlur}
          />
        </ReferralContainer> */}

        {/* ST-7185: Registration :: Referral Page : Remove Page --> */}

        <ButtonWrapper>
          <StyledButton
            type="submit"
            variant="primary"
            data-testid="registerSubmit"
            // disabled={!isValid}
          >
            Continue
          </StyledButton>
        </ButtonWrapper>
      </fieldset>
    </form>
  )
}

RegisterForm.defaultProps = {
  handleSubmit: null,
  handleChange: null,
  handleBlur: null,
  setFieldValue: null,
  values: {},
  errors: {},
  touched: {},
  isSubmitting: false,
  isValid: false,
  disabled: false,
  method: 'get',
  action: '',
}

RegisterForm.propTypes = {
  handleSubmit: PropTypes.func,
  handleChange: PropTypes.func,
  handleBlur: PropTypes.func,
  values: PropTypes.shape(),
  errors: PropTypes.shape(),
  touched: PropTypes.shape(),
  isSubmitting: PropTypes.bool,
  isValid: PropTypes.bool,
  disabled: PropTypes.bool,
  method: PropTypes.oneOf(['get', 'post']),
  action: PropTypes.string,
  setFieldValue: PropTypes.func,
}

export default RegisterForm
